import { ButtonHTMLAttributes } from 'react'
import { twMerge as twm } from 'tailwind-merge'

import { Icon, IconNameAndCategoryString } from '../../Icon'
import Label from '../../app/design/Label'

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
    title: string
    isSelected?: boolean
    size?: 'small' | 'medium'
    onClick?: () => void
    onRemove?: () => void
    icon?: IconNameAndCategoryString
    disabled?: boolean
}

export const Chip = ({
    title,
    isSelected = false,
    className,
    size = 'medium',
    onClick,
    onRemove,
    icon,
    disabled,
    ...props
}: Props) => {
    const sizeClass =
        size === 'small' ? 'min-w-[60px] px-3 py-2 h-[36px]' : ' min-w-[72px] px-4 py-3 h-[48px]'

    return (
        <button
            {...props}
            className={twm(
                className,
                'flex items-center justify-center gap-x-2 rounded-full border px-3 outline',
                sizeClass,
                'hover:bg-linear-to-b hover:from-black/4 hover:to-black/4',
                isSelected
                    ? 'hover:bg-secondary-sec bg-secondary-100 text-secondary-400 outline-secondary-400 outline-2 -outline-offset-2'
                    : 'border-gray-300 text-gray-600 outline-transparent',
                disabled && 'pointer-events-none border-gray-200 text-gray-400'
            )}
            onClick={onRemove ?? onClick}
        >
            {icon && <Icon icon={icon} shouldInheritColor />}
            <Label size={size === 'small' ? 'sm' : 'md'} className="pointer-events-none align-top">
                {title}
            </Label>

            {onRemove !== undefined && <Icon icon="close.small" shouldInheritColor />}
        </button>
    )
}
